$(() => {
    // Load page parameters
    if ($('.block.rebates').length) {
        var parent = $('.block.rebates');
        const urlParams = new URLSearchParams(window.location.search);
        var getPosts = false;

        // Selec the type
        if (urlParams.has('type')) {
            var type = urlParams.get('type');
            var selectField = parent.find('.step-one select[name="type"]');
            selectField.find('option[value="'+type+'"]').prop('selected', true);
            update_form_field_step(selectField.val());
            getPosts = true;
        }

        // Select category option
        if (urlParams.has('category')) {
            var category_id = urlParams.get('category');
            parent.find('.step-two .options .option[data-value="'+category_id+'"]').addClass('active');
        }

        // If we have options pre-selected
        if (getPosts) {

            // Scroll to the block loading
            var button = parent.find('.find-rebates');
            var height = button.offset().top - 180;
            $('html, body').animate({scrollTop: height}, 100);

            // Get the posts
            get_posts();
        }
    }

    // Update which step you're on based on the value of the "type" select field
    function update_form_field_step(val) {
        if (!val) {
            $('.block.rebates .form-container .fields.step-two .options').hide();
            $('.block.rebates .form-container .fields.step-two').hide();
        }

        if (val == 'home') {
            $('.block.rebates .form-container .fields.step-two').show();
            $('.block.rebates .form-container .fields.step-two .options.business').hide();
            $('.block.rebates .form-container .fields.step-two .options.home').css('display', 'flex');
        }

        if (val == 'business') {
            $('.block.rebates .form-container .fields.step-two').show();
            $('.block.rebates .form-container .fields.step-two .options.home').hide();
            $('.block.rebates .form-container .fields.step-two .options.business').css('display', 'flex');
        }
    }

    // Selecting rebate type - Step 1
    $('.block.rebates select[name="type"]').on('change', function() {
        var val = $(this).val();
        update_form_field_step(val);
    });

    // Selecting rebate categories - Step 2
    $('.block.rebates .step-two .options .option').on('click', function() {
        var option = $(this);

        if (option.hasClass('active')) {
            option.removeClass('active');
        }
        else {
            option.addClass('active');
        }
    });

    // Search for rebates
    $('.block.rebates .find-rebates').on('click', function(e) {
        e.preventDefault();
        var parent = $('.block.rebates');
        if (!parent.length) return false;
        var results = parent.find('.results-filter');
        results.hide();

        // Scroll to the block loading
        var button = parent.find('.find-rebates');
        var height = button.offset().top - 180;
        $('html, body').animate({scrollTop: height}, 100);

        get_posts();
    });

    // Reset filters
    $('.block.rebates .reset-filters').on('click', function(e) {
        e.preventDefault();
        var parent = $('.block.rebates');
        if (!parent.length) return false;

        // Reset the form fields
        parent.find('select[name="type"]').val('');
        parent.find('select[name="state"]').val('');
        $('.block.rebates .form-container .fields.step-two .options .option').removeClass('active');
        $('.block.rebates .form-container .fields.step-two .options').hide();
        $('.block.rebates .form-container .fields.step-two').hide();

        // Scroll to top of block
        var height = parent.offset().top - 180;
		$('html, body').animate({scrollTop: height}, 100);
    });

    // Filter option buttons
    $('.rebates .filters .option').on('click', function() {
        var option = $(this);

        if (option.hasClass('active')) {
            option.removeClass('active');
        }
        else {
            option.addClass('active');
        }

        get_posts();
    })

    // Sort By
    $('.block.rebates .results-filter .sort select[name="sort"]').on('change', function(e) {
        get_posts();
    });

    /**
     * Get rebates
     */
    function get_posts() {
        var parent = $('.block.rebates');
        if (!parent.length) return false;
        var container = parent.find('.content .items');
        var featured_container = parent.find('.featured .items');
        if (!container.length) return false;
        var results = parent.find('.results-filter');
        var pagination = $('.block.pagination');

        // Get type of rebates
        var type = parent.find('select[name="type"]').val();
        if (!type) return false;
        var parent_id = parent.find('select[name="type"] option:selected').attr('data-term-id');
        if (!parent_id) return false;

        // Remove existing items in the container
        container.empty();
        featured_container.empty();

        // Show loading
        parent.find('.results-section').addClass('active');
        parent.find('.loading').addClass('active');
        pagination.hide();
        parent.find('.results-section .footer .legend').hide();
        parent.find('.results-section .featured').hide();

        // Get current filter settings
        var ids = [];
        parent.find('.step-two .options.'+type+' .option.active').each(function() {
            var value = $(this).attr('data-value');
            ids.push(value);
        });
        var state = parent.find('select[name="state"]').val();
        var multiple_upgrade = results.find('.filters .option.multiple-upgrade').hasClass('active');
        var energy_star = results.find('.filters .option.energy-star').hasClass('active');

        // Get order settings
        var order = results.find('select[name="sort"]').val();

        // Define tax query
        var taxQuery = null;
        if (parent_id) {
            taxQuery = [{
                taxonomy: 'rebate_category',
                field: 'term_id',
                terms: parent_id,
                operator: 'IN',
            }];
        }
        if (ids.length) {
            taxQuery = [{
                taxonomy: 'rebate_category',
                field: 'term_id',
                terms: ids,
                operator: 'IN',
            }];
        }

        // Define meta query
        var metaQuery = null;
        if (state || multiple_upgrade || energy_star) metaQuery = [];
        if (state) {
            metaQuery.push({
                key: 'states',
	            value: state,
                compare: 'LIKE',
            });
        }
        if (multiple_upgrade) {
            metaQuery.push({
                key: 'multiple_upgrade_bonus',
	            value: 1,
                compare: '=',
            });
        }
        if (energy_star) {
            metaQuery.push({
                key: 'energy_star',
	            value: 1,
                compare: '=',
            });
        }

        // Grab featured posts via Ajax
        $.ajax({
            type: 'POST',
            url: ajaxurl,
            dataType: 'json',
            data: { 
                action: 'get_featured_rebates',
                parent_id: parent_id,
                tax_query: taxQuery,
                meta_query: metaQuery,
            },
            success: function(response) {
                // Error message
                if (!response.success) {
                    console.log(response.message);
                    return false;
                }

                var data = response.data;

                // Show no data message
                if (!data.length) {
                    // container.append('<div class="well">No posts found.</div>');
                }

                // Loop through the data
                else {
                    for (var i = 0; i < data.length; i++) {
                        var item = data[i];

                        // Create a div for each item
                        var $item = $(item.html);
                        featured_container.append($item);
                    }

                    // Show featured container
                    parent.find('.results-section .featured').show();
                    var rebateTypeText = type.charAt(0).toUpperCase() + type.slice(1);
                    parent.find('.results-section .featured .rebate-type-text').text(rebateTypeText);
                }
            }
        });

        // Grab the posts via Ajax
        $.ajax({
            type: 'POST',
            url: ajaxurl,
            dataType: 'json',
            data: { 
                action: 'get_rebates',
                tax_query: taxQuery,
                meta_query: metaQuery,
                order: order,
            },
            success: function(response) {
                // Error message
                if (!response.success) {
                    console.log(response.message);
                    return false;
                }

                var data = response.data;

                // Show no data message
                if (!data.length) {
                    // container.append('<div class="well">No posts found.</div>');
                }

                // Loop through the data
                else {
                    for (var i = 0; i < data.length; i++) {
                        var item = data[i];

                        // Create a div for each item
                        var $item = $(item.html);
                        container.append($item);
                    }
                }

                // Hide loading
                parent.find('.loading').removeClass('active');

                // Update results header
                var name = results.attr('data-item-name');
                var singular = results.attr('data-item-singular');
                var itemText = (data.length == 0 || data.length > 1) ? name : singular;
                results.find('.results-number').text(data.length);
                results.find('.results-item-text').text(itemText);
                results.show();

                // Update results footer
                parent.find('.results-section .footer .legend').show();

                // Update AJAX pagination
                pagination.show();
                window.pagination.setTotal(data.length);
                window.pagination.update();
            }
        });
    }
})